import Vue from "vue";

import ViewListIcon from "vue-material-design-icons/ViewList";
import PencilIcon from "vue-material-design-icons/Pencil";

// Register the Icons so Webpack includes them and we can use them
Vue.component("ViewListIcon", ViewListIcon);
Vue.component("PencilIcon", PencilIcon);

export default [
  {
    name: "Post",
    children: [
      {
        icon: "view-list",
        title: "List Post",
        to: {
          name: "post.list",
          query: {
            limit: 10,
            filter: "active",
            sort: "created_date",
            order: "desc",
          },
        },
        loggedIn: true,
      },
      {
        icon: "pencil",
        title: "New Post",
        to: { name: "post.create" },
        loggedIn: true,
      },
    ],
    loggedIn: true,
  },
  {
    name: "Comment",
    children: [
      {
        icon: "view-list",
        title: "List Comment",
        to: {
          name: "comment.list",
          query: {
            limit: 10,
            filter: "review",
            sort: "created_date",
            order: "desc",
          },
        },
        loggedIn: true,
      },
      {
        icon: "pencil",
        title: "New Comment",
        to: { name: "comment.create" },
        loggedIn: true,
      },
    ],
    loggedIn: true,
  },
  // {
  //   name: "Feed",
  //   children: [
  //     {
  //       icon: "view-list",
  //       title: "View",
  //       to: { name: "news.feed" },
  //       loggedIn: true,
  //     },
  //   ],
  //   loggedIn: true,
  // },
  {
    name: "Manage",
    children: [],
    loggedIn: true,
  },
];
